import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000DeleteRecordDialog from '../../u2000Core/components/dialog/U2000DeleteRecordDialog';
import { NS } from '../U3204';
import { u3204ResolveConversationDisplayTitle } from '../utils/u3204ResolveConversationDisplayTitle';

interface U3204ConversationDeleteDlgProps {
  isOpen: boolean;
  conversationTitle: string | null;
  onClose: () => void;
  onConfirm: () => Promise<boolean>;
}

const U3204ConversationDeleteDlg: React.FC<U3204ConversationDeleteDlgProps> = ({
  isOpen,
  conversationTitle,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation(NS);

  const handleClose = async (result: 'yes' | 'no') => {
    if (result === 'no') {
      onClose();
      return;
    }

    const ok = await onConfirm();
    if (ok) onClose();
  };

  return (
    <U2000DeleteRecordDialog
      isOpen={isOpen}
      onClose={handleClose}
      title={t('deleteDialogTitle', { ns: NS })}
    >
      <p className="text-sm text-muted-foreground">
        {t('deleteDialogMessage', {
          ns: NS,
          title: u3204ResolveConversationDisplayTitle(conversationTitle, t('newConversation', { ns: NS })),
        })}
      </p>
    </U2000DeleteRecordDialog>
  );
};

export default U3204ConversationDeleteDlg;
